import { render, staticRenderFns } from "./MenuDocument.vue?vue&type=template&id=09eccee4&scoped=true&"
import script from "./MenuDocument.vue?vue&type=script&lang=js&"
export * from "./MenuDocument.vue?vue&type=script&lang=js&"
import style0 from "./MenuDocument.vue?vue&type=style&index=0&id=09eccee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eccee4",
  null
  
)

export default component.exports